import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { FieldFilterDetails, FilterField } from './types';
import { _mockFieldFilters } from './getFieldFilters';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getFieldFilter: QueryFunction<
  FieldFilterDetails,
  ['/field-filter', string]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockStackFilters(queryKey[1]));
  if (!queryKey[1] || queryKey[1].trim() === '') {
    throw new Error('Field filter ID is required');
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    filter: {
      configuration: {
        fieldIds?: FilterField[];
        orderedDocumentTypeIds?: {
          documentTypeId: string;
          required: boolean;
        }[];
        columnFilters?: { id: string; value: string }[];
      };
      name: string;
      id: string;
      visibility: 'private' | 'public';
    };
  }>(`/search-filters/${queryKey[1]}`, {
    method: 'GET',
  });
  if (response.data)
    return {
      id: response.data.filter.id,
      name: response.data.filter.name,
      isOrganization: response.data.filter.visibility === 'public',
      fields:
        response.data.filter.configuration.fieldIds ??
        response.data.filter.configuration.orderedDocumentTypeIds ??
        [],
      columnFilters: response.data.filter.configuration.columnFilters,
    };
  throw new Error('Failed to fetch field filter');
};

export default getFieldFilter;

const _mockStackFilters = (id: string): FieldFilterDetails => ({
  id,
  name: _mockFieldFilters[((parseInt(id) || 1) - 1) % _mockFieldFilters.length]
    .name,
  isOrganization: true,
  fields: [
    { fieldId: 'field-0' }, // Borrower
    { fieldId: 'field-1' }, // Status
    { fieldId: 'field-2' }, // Loan Purpose
    { fieldId: 'field-3' }, // Loan Officer
    { fieldId: 'field-6' }, // Loan Amount
  ],
  columnFilters: [
    { id: 'borrower', value: 'John' }, // Mock column filter
    { id: 'status', value: 'Active' }, // Mock column filter
  ],
});
